import React from 'react';
import { DatoCmsImageListItem } from '../../../schema/datocms/blocks';
import { getTextAlignmentClass } from '../../../utilities';
import HtmlEntityTextComponent from '../../html-entity-text/html-entity-text-component';
import HtmlStringComponent from '../../html-string/html-string-component';
import ApiImageComponent from '../api-image/api-image-component';

const ImageListItemComponent = ({ title, titleAlignment, descriptionHtml, apiImage }: DatoCmsImageListItem): React.ReactElement => {
    let imageContent: JSX.Element | undefined = undefined;
    if (apiImage && apiImage[0]) {
        imageContent = (
            <ApiImageComponent
                apiImage={apiImage[0]}
                isStyled={true}
                className="block bg-contain bg-center bg-no-repeat w-full"
                style={
                    { minHeight: '150px' }
                }
                role="img"
                aria-label={apiImage[0].image.alt}></ApiImageComponent>

        );
    }

    const imageItem = (
        <div className="flex flex-col space-y-4">
            {imageContent}

            { title && <h3 className={`${getTextAlignmentClass(titleAlignment)}`}>
                { <HtmlEntityTextComponent text={title} /> }
            </h3> }

            { descriptionHtml && <HtmlStringComponent htmlString={descriptionHtml} skipAlignmentClasses={true} /> }
        </div>
    );

    return imageItem;
};

export default ImageListItemComponent;
